import { combineReducers } from 'redux';
import globalLoader from './globalLoader';
import initialData from './initialData';

export default combineReducers({
  globalLoader,
  initialData,
});
